const contentTypeHeader = { "Content-Type": "application/json" };

const getAuthHeader = () => {
  let jwt: string;
  if (import.meta.env.VITE_JWT_TEST_TOKEN == "production")
    jwt = window.HackneyGamesSDK.getAuthToken().jwt;
  else jwt = import.meta.env.VITE_JWT_TEST_TOKEN;

  if (!jwt || jwt === "null") {
    return null;
  }

  return { Authorization: "Bearer " + jwt };
};

export const getHeadersJWT = () => ({
  ...contentTypeHeader,
  ...getAuthHeader(),
});
